firebird.factory('mediaDeviceService', [
    '$window',
    'logService',
    'configService',
    function ($window, logService, configService) {
        var service = {
            getUserMedia: getUserMedia,
            handleNewStream: handleNewStream
        };

        service.tracks = [];

        const logger = logService.createLoggerWithSource('[mediaDeviceService]');

        init();

        return service;

        function init() {
            $window.Janus.getUserMedia = getUserMedia;
        }

        function handleNewStream(stream) {
            // Store all tracks with constraints
            stream.getTracks().forEach(track => {
                service.tracks.push({
                    track,
                    constraints: track.getConstraints(),
                    cloneCount: 1
                });
                const originalStop = track.stop;
                track.stop = function () {
                    const trackIndex = service.tracks.findIndex(t => t.track === this);
                    if (trackIndex >= 0) {
                        const trackObj = service.tracks[trackIndex];
                        trackObj.cloneCount--;
                        if (trackObj.cloneCount <= 0) {
                            // If all clones stopped, then stop the track
                            originalStop.apply(this, arguments);
                            service.tracks.splice(trackIndex, 1);
                            logger.log(
                                'MediaStreamTrack.prototype.stop',
                                'Track removed from the internal list',
                                trackObj
                            );
                        }
                    } else {
                        // If not in list, then stop the track
                        originalStop.apply(this, arguments);
                    }
                };
            });
        }

        // Function to get user media with specified constraints
        function getUserMedia(constraints) {
            logger.log('getUserMedia', 'Called with constraints', constraints);

            if (!$window.navigator?.mediaDevices?.getUserMedia) {
                logger.error('getUserMedia', 'method not supported');
                return Promise.reject('Not supported');
            }

            const existingTracks = service.tracks.map(({ track: { id, kind } }) => ({ id, kind }));
            logger.log('getUserMedia', 'Existing media tracks :: ', existingTracks);

            const useMediaService = configService.getValue('useMediaService');
            const useRefCount = useMediaService && useMediaService !== 'nocount';
            if (useRefCount) {
                // Filter tracks based on constraints
                const matchingTracks = service.tracks.filter(trackObj => {
                    const trackConstraints = trackObj.constraints;
                    return JSON.stringify(trackConstraints) === JSON.stringify(constraints);
                });

                if (matchingTracks?.length > 0) {
                    // If matching tracks found, return media stream from tracks
                    const stream = new MediaStream();
                    matchingTracks.forEach(trackObj => {
                        stream.addTrack(trackObj.track);
                        trackObj.cloneCount++; // Increment clone count
                    });
                    logger.log('getUserMedia', 'Success:: Found reference in existing tracks', matchingTracks);
                    return Promise.resolve(stream);
                }
            }

            return new Promise((resolve, reject) => {
                $window.navigator.mediaDevices
                    .getUserMedia(constraints)
                    .then(stream => {
                        logger.log('getUserMedia', 'Success :', stream);
                        handleNewStream(stream);
                        return resolve(stream);
                    })
                    .catch(error => {
                        logger.error('getUserMedia', 'Error :', error);
                        return reject(error);
                    });
            });
        }
    }
]);
